import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { SANDBOX_RESET_DATA_KINDS } from '../admin/sandbox-reset.schemas';

// Published when GitHub accepted an operator's dispatch of the sandbox data reset. Audit-only: who started it and
// with which copy. A refused or failed start is not published.
export const SandboxResetStartedPayloadSchema = z.object({
  actor: ActorSchema,
  dataKind: z.enum(SANDBOX_RESET_DATA_KINDS),
  runId: z.string().min(1),
  occurredAt: z.iso.datetime(),
});

export type SandboxResetStartedPayload = z.infer<typeof SandboxResetStartedPayloadSchema>;
